<template>
    <div class="d-flex justify-content-around pt-2 border-top">

        <div v-for="(tab, index) in model.app.nav.tabs" class="d-flex flex-column justify-content-center pointer"
             :class="tabClasses(tab)" @click="onTabClick(tab)">

            <div>
                <ion-icon v-if="tab.icon" :src="'/resources/ionicons/' + tab.icon + '.svg'" size="large"></ion-icon>
            </div>

            <div class="text-center" style="font-size: .75rem;" >
                {{tab.label}}
            </div>

        </div>


    </div>
</template>

<script>
    export default {
        name: 'MobileTabsContainer',
        props: ['view', 'prop2'],
        data () {
            return {
                model: webase.model
            }
        },
        mounted () {
        },
        methods: {
            isCurrentView(tab) {
                return this.view.id === tab.resource
            },
            tabClasses(tab) {
                return this.isCurrentView(tab) ? 'text-primary' : 'text-dark'
            },
            onTabClick(tab) {
                if(!this.isCurrentView(tab)) {
                    this.$router.push({ name: 'view-renderer', params: {id: tab.resource}})
                }
            }
        }
    }
</script>
